export const getBaseurl = () => {
  const base = process.env.REACT_APP_API_BASE_URL;

  if (!base) {
    console.error('REACT_APP_API_BASE_URL is not defined in environment');
  }

  return base;
};

export const getEnv = () => {
  return process.env.REACT_APP_ENV || 'prod';
};

export const BASE_URL = getBaseurl();
